<template>
    <el-dialog title="分组明细" :visible.sync="isVisible" width="80%" @close="handleClose">
        <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
            @search-change="searchChange" @refresh-change="refreshChange(page)" @size-change="pageSizeChange"
            @current-change="pageChange" @addBtn="handleAdd">
            <template slot="menuLeft">
                <el-button type="text" icon="el-icon-plus" size="small" plain @click.stop="handleAdd">新增</el-button>
                <!-- 批量关联子阶段 -->
                <el-button type="text" icon="el-icon-edit" size="small"
                    @click.stop="handleBatchLink">批量关联子阶段</el-button>
                <!-- 删除 -->
                <el-button type="text" icon="el-icon-delete" size="small" @click="handleDelete">删除</el-button>
            </template>
            <!-- 已关联子阶段列 -->
            <template slot="goodsNames" slot-scope="scope">
                <template v-if="(scope.row.goodsNames || []).length">
                    <el-tag v-for="(name, i) in scope.row.goodsNames" :key="i" size="mini" type="success"
                        effect="plain" style="margin: 2px">{{ name }}</el-tag>
                </template>
                <span v-else style="color: #c0c4cc">未关联</span>
            </template>
            <template slot-scope="scope" slot="menu">
                <el-button type="text" icon="el-icon-edit" size="small"
                    @click="handleLinkGoods(scope.row)">关联子阶段</el-button>
                <el-button type="text"
                    :icon="scope.row.walletFrozen === 'YES' ? 'el-icon-success' : 'el-icon-error'"
                    size="small" @click="handleToggleWallet(scope.row)">{{ scope.row.walletFrozen === 'YES' ? '解冻钱包' : '冻结钱包' }}</el-button>
                <!-- 转移 -->
                <el-button type="text" icon="el-icon-edit" size="small"
                    @click="handleTransfer(scope.row)">转移</el-button>
                <!-- 删除 -->
                <el-button type="text" icon="el-icon-delete" size="small"
                    @click="handleDelete(scope.row)">删除</el-button>
            </template>
        </avue-crud>
        <!-- 关联子阶段弹窗（单人/批量复用） -->
        <el-dialog :title="linkDialogTitle" :visible.sync="linkDialogVisible" width="640px" append-to-body
            :close-on-click-modal="false" @close="resetLinkForm">
            <div v-if="linkMode === 'batch' && linkSelections.length" class="link-targets">
                <i class="el-icon-user-solid"></i>
                <span>已选 {{ linkSelections.length }} 位工程师：</span>
                <el-tag v-for="(u, i) in linkSelections.slice(0, 8)" :key="i" size="mini" style="margin: 2px">
                    {{ u.userName }}
                </el-tag>
                <span v-if="linkSelections.length > 8" style="color:#909399">等共 {{ linkSelections.length }} 人</span>
            </div>
            <div v-loading="goodsLoading">
                <div v-if="!goodsLoading && goodsGroupList.length === 0" class="link-empty">
                    <i class="el-icon-warning-outline"></i>
                    <span>当前部门暂无可选子阶段</span>
                </div>
                <div v-for="group in goodsGroupList" :key="group.parentId" class="goods-group">
                    <div class="goods-group__head">
                        <el-checkbox :value="isGroupAllChecked(group)" :indeterminate="isGroupIndeterminate(group)"
                            @change="toggleGroupAll(group, $event)">
                            <span class="goods-group__title">{{ group.parentName }}</span>
                        </el-checkbox>
                        <span class="goods-group__count">
                            已选 {{ countGroupChecked(group) }}/{{ (group.children || []).length }}
                        </span>
                    </div>
                    <el-checkbox-group v-model="linkForm.goodsIds" class="goods-group__body">
                        <el-checkbox v-for="c in group.children" :key="c.id" :label="c.id">
                            {{ c.name }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="link-tip">
                <i class="el-icon-info"></i>
                保存后将<strong>覆盖式</strong>更新选中工程师的子阶段关联；不勾选任何子阶段并保存即表示清空关联
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="linkDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="linkSubmitLoading" @click="confirmLinkGoods">保 存</el-button>
            </div>
        </el-dialog>
        <!-- 新增工程师对话框 -->
        <el-dialog title="新增工程师" :visible.sync="addDialogVisible" width="500px" @close="addDialogVisible = false"
            append-to-body>
            <el-form ref="addFormRef" :model="addForm" label-width="100px">
                <el-form-item label="选择工程师" prop="userId">
                    <el-select v-model="addForm.userId" placeholder="请选择工程师" filterable remote :remote-method="remoteSearchAgent" style="width: 100%">
                        <el-option v-for="engineer in engineerList" :key="engineer.id" :label="engineer.realName" :value="engineer.id"
                            @click.native="handleAgentChange(engineer)"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="工程师名称" prop="userName">
                        <el-input v-model="addForm.userName" placeholder="工程师名称" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="工程师电话" prop="userMobile">
                        <el-input v-model="addForm.userMobile" placeholder="工程师电话" disabled></el-input>
                    </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmAdd">确定</el-button>
            </div>
        </el-dialog>
        <!-- 转移分组对话框 -->
        <el-dialog title="转移到分组" :visible.sync="transferDialogVisible" width="500px" append-to-body
            @close="transferDialogVisible = false">
            <el-form ref="transferFormRef" :model="transferForm" label-width="100px">
                <el-form-item label="目标分组" prop="targetGroupId">
                    <el-select v-model="transferForm.targetGroupId" placeholder="请选择目标分组">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.groupName"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="transferDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmTransfer">确定</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>
<script>
import { getGroupDetails, addGroupDetail, deleteGroupDetails, transferGroupDetail, findAgent, findUser, freezeWallet, unfreezeWallet, findGoodsChildren, saveEngineerGoods, batchSaveEngineerGoods } from '@/api/sales/accountGroup';
export default {
    name: 'GroupDetails',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        groupId: {
            type: [Number, String],
            required: true
        }
    },
    watch: {
        visible(newVal) {
            this.isVisible = newVal;
            if (newVal && this.groupId) {
                this.handleDetailList();
            }
        },
        groupId(newVal) {
            if (this.visible && newVal) {
                this.handleDetailList();
            }
        }
    },
    data() {
        return {
            isVisible: this.visible,
            tableOption: {
                align: 'center',
                menuAlign: 'center',
                headerAlign: 'center',
                border: true,
                expand: false,
                stripe: false,
                showHeader: true,
                index: false,
                selection: true,
                menu: true,
                menuWidth: 380,
                page: true,
                addBtn: false,
                editBtn: false,
                delBtn: false,
                viewBtn: false,
                menuType: 'text',
                column: [
                    {
                        label: 'ID',
                        prop: 'id',
                        type: 'input',
                        hide: true
                    },
                    {
                        label: '工程师ID',
                        prop: 'userId',
                        type: 'input',
                        hide: true
                    },
                    {
                        label: '工程师名称',
                        prop: 'userName',
                        type: 'input',
                        search: true
                    },
                    /* {
                        label: '工程师电话',
                        prop: 'userMobile',
                        type: 'input',
                        search: true
                    }, */
                    {
                        label: '钱包状态',
                        prop: 'walletFrozen',
                        type: 'select',
                        width: 100,
                        dicData: [
                            { label: '已冻结', value: 'YES'},
                            { label: '正常', value: 'NO' }
                        ]
                    },
                    {
                        label: '已关联子阶段',
                        prop: 'goodsNames',
                        type: 'input',
                        slot: true,
                        width: 260,
                        hide: false
                    },
                    {
                        label: '创建时间',
                        prop: 'createTime',
                        type: 'datetime',
                        format: 'yyyy-MM-dd HH:mm:ss',
                        // valueFormat: 'timestamp'
                    }
                ]
            },
            tableData: [],
            tableLoading: false,
            page: {
                total: 0,
                currentPage: 1,
                pageSize: 10
            },
            // 保存要转移的记录
            transferSelections: [],
            // 新增工程师表单
            addForm: {
                userId: '',
                userName: '',
                userMobile: ''
            },
            addDialogVisible: false,
            // 转移分组表单
            transferForm: {
                targetGroupId: ''
            },
            transferDialogVisible: false,
            // 可选分组列表
            groupList: [],
            // 工程师列表
            engineerList: [],
            // 工程师搜索关键词
            engineerSearchKeyword: '',
            /* ====== 子阶段关联管理 ====== */
            // 关联弹窗：'single' | 'batch'
            linkMode: 'single',
            linkDialogVisible: false,
            linkSubmitLoading: false,
            // 可选子阶段分组列表
            goodsGroupList: [],
            goodsLoading: false,
            // 当前关联弹窗选中的子阶段 goodsId 列表
            linkForm: {
                goodsIds: []
            },
            // 单人模式下的目标工程师；批量模式下为选中工程师数组
            linkSelections: []
        };
    },
    computed: {
        linkDialogTitle() {
            return this.linkMode === 'batch' ? '批量关联子阶段' : '关联子阶段';
        }
    },
    methods: {
        handleDetailList() {
            if (!this.groupId) return;
            this.tableLoading = true;
            const params = {
                groupId: this.groupId,
                page: this.page.currentPage,
                size: this.page.pageSize
            };
            getGroupDetails(params)
                .then(res => {
                    if (res.code === '200') {
                        const data = JSON.parse(res.data);
                        console.log('groupDetails.vue ~ line: 183 ~ data ->', data);
                        this.tableData = data.rows || [];
                        this.page.total = data.total || 0;
                    } else {
                        this.tableData = [];
                        this.page.total = 0;
                        this.$message.error('获取分组明细失败');
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 190 ~ error ->', error);
                    this.tableData = [];
                    this.page.total = 0;
                    this.$message.error('获取分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        pageChange(page) {
            this.page.currentPage = page;
            this.handleDetailList();
        },
        pageSizeChange(pageSize) {
            this.page.pageSize = pageSize;
            this.handleDetailList();
        },
        searchChange(params) {
            this.page.currentPage = 1;
            const searchParams = {
                groupId: this.groupId,
                page: 1,
                size: this.page.pageSize
            };
            // 添加搜索参数
            if (params.userName) {
                searchParams.userName = params.userName;
            }
            if (params.userMobile) {
                searchParams.userMobile = params.userMobile;
            }
            this.tableLoading = true;
            getGroupDetails(searchParams)
                .then(res => {
                    if (res.code === '200') {
                        const data = JSON.parse(res.data);
                        this.tableData = data.rows || [];
                        this.page.total = data.total || 0;
                    } else {
                        this.tableData = [];
                        this.page.total = 0;
                        this.$message.error('搜索分组明细失败');
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 235 ~ error ->', error);
                    this.tableData = [];
                    this.page.total = 0;
                    this.$message.error('搜索分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        refreshChange(page) {
            this.page.currentPage = page.currentPage;
            this.page.pageSize = page.pageSize;
            this.handleDetailList();
        },
        handleClose() {
            this.$emit('close');
        },
        // 处理新增按钮点击
        handleAdd() {
            this.addForm = {
                userId: '',
                userName: '',
                userMobile: ''
            };
            this.engineerList = [];
            this.addDialogVisible = true;
        },
        // 远程搜索工程师
        remoteSearchAgent(query) {
            if (query === '' || !/^\d{8,}$/.test(query)) {
                this.engineerList = [];
                return;
            }

            const params = {
                type: "JOINS_ENGINEER",
                mobile: query
            };

            findAgent(params)
                .then(res => {
                    console.log('groupDetails.vue ~ line: 281 ~ res ->', res);
                    if (res.code == '200') {
                        const data = JSON.parse(res.data);
                        console.log('groupDetails.vue ~ line: 283 ~ data ->', data);
                        this.engineerList = data || [];
                    } else {
                        this.$message.error('搜索工程师失败');
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 283 ~ error ->', error);
                    this.$message.error('搜索工程师异常');
                });
        },
        // 处理工程师选择
        handleAgentChange(engineer) {
            console.log('groupDetails.vue ~ line: 297 ~ engineer ->', engineer);
            if (engineer) {
                this.addForm.userId = engineer.id;
                this.addForm.userName = engineer.realName;
                this.addForm.userMobile = engineer.mobile || '';
                this.addForm.groupId = this.groupId;
            } else {
                this.addForm.userId = '';
                this.addForm.userName = '';
                this.addForm.userMobile = '';
            }
        },

        // 确认新增分组明细
        confirmAdd() {
            // 验证表单
            if (!this.addForm.userId || !this.addForm.userName) {
                this.$message.error('请填写完整的工程师信息');
                return;
            }
            const data = {
                userId: this.addForm.userId,
                groupId: this.groupId,
                userName: this.addForm.userName,
                userMobile: this.addForm.userMobile
            };
            this.tableLoading = true;
            addGroupDetail(data)
                .then(res => {
                    if (res.code === '200') {
                        this.$message.success('新增成功');
                        this.addDialogVisible = false;
                        this.handleDetailList(); // 重新加载列表
                    } else {
                        this.$message.error('新增失败：' + (res.message || '未知错误'));
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 327 ~ error ->', error);
                    this.$message.error('新增分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        // 处理删除按钮点击
        handleDelete(row) {
            let selections;
            // 如果传入了行数据，则为单个删除
            if (row && row.id) {
                selections = [row];
            } else {
                // 否则为批量删除
                selections = this.$refs.crud.$refs.table.selection;
                if (!selections || selections.length === 0) {
                    this.$message.warning('请先选择要删除的记录');
                    return;
                }
            }
            this.$confirm('确定要删除选中的 ' + selections.length + ' 条记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirmDelete(selections);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        // 确认删除分组明细
        confirmDelete(selections) {
            const ids = selections.map(item => item.id).join(',');
            this.tableLoading = true;
            deleteGroupDetails(ids)
                .then(res => {
                    if (res.code === '200') {
                        this.$message.success('删除成功');
                        this.handleDetailList(); // 重新加载列表
                    } else {
                        this.$message.error('删除失败：' + (res.message || '未知错误'));
                    }
                })
                .catch(error => {
                    console.log('groupDetails.vue ~ line: 371 ~ error ->', error);
                    this.$message.error('删除分组明细异常');
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        // 处理转移按钮点击
        handleTransfer(row) {
            // 保存当前要转移的记录（可能是单行或多行选中的）
            if (row && row.id) {
                // 如果传入了行数据，则为单个转移
                this.transferSelections = [row];
            } else {
                // 否则尝试获取批量选中的记录
                this.transferSelections = this.$refs.crud.$refs.table.selection
                if (!this.transferSelections || this.transferSelections.length === 0) {
                    this.$message.warning('请选择要转移的记录');
                    return;
                }
            }
            // 获取分组列表
            this.getGroupList();
            this.transferForm = {
                targetGroupId: ''
            };
            this.transferDialogVisible = true;
        },
        // 获取分组列表
        getGroupList() {
            findUser({ page: 1, size: '' }) // 获取所有分组，与index.vue保持一致使用findUser
                .then(res => {
                    if (res.code === '200') {
                        const data = JSON.parse(res.data);
                        this.groupList = data.rows || [];
                    } else {
                        this.$message.error('获取分组列表失败');
                    }
                })
                .catch(error => {
                    console.log('error', error);
                    this.$message.error('获取分组列表异常');
                });
        },
        // 确认转移分组明细
        confirmTransfer() {
            if (!this.transferForm.targetGroupId) {
                this.$message.error('请选择目标分组');
                return;
            }
            if (!this.transferSelections || this.transferSelections.length === 0) {
                this.$message.warning('请选择要转移的记录');
                return;
            }
            // 处理多个转移
            this.tableLoading = true;
            try {
                // 获取选中的ID列表，添加安全检查
                const ids = this.transferSelections
                    .filter(item => item && item.id !== undefined)
                    .map(item => item.id)
                    .join(',');
                if (!ids) {
                    throw new Error('没有获取到有效的记录ID');
                }
                const data = {
                    id: ids,  // 传递多个ID
                    groupId: this.transferForm.targetGroupId
                };
                transferGroupDetail(data)
                    .then(res => {
                        if (res.code === '200') {
                            this.$message.success('转移成功');
                            this.transferDialogVisible = false;
                            this.handleDetailList(); // 重新加载列表
                        } else {
                            this.$message.error('转移失败：' + (res.message || '未知错误'));
                        }
                    })
                    .catch(error => {
                        console.log('groupDetails.vue ~ line: 457 ~ error ->', error);
                        this.$message.error('转移分组明细异常');
                    })
                    .finally(() => {
                        this.tableLoading = false;
                    });
            } catch (error) {
                this.$message.error('处理转移数据异常：' + error.message);
                this.tableLoading = false;
            }
        },
        /* ====== 子阶段关联管理 ====== */
        // 单人编辑关联
        handleLinkGoods(row) {
            if (!row || !row.userId) {
                this.$message.warning('该记录缺少工程师ID，无法关联');
                return;
            }
            this.linkMode = 'single';
            this.linkSelections = [row];
            // 回显当前已关联的子阶段
            this.linkForm.goodsIds = Array.isArray(row.goodsIds) ? row.goodsIds.slice() : [];
            this.linkDialogVisible = true;
            this.loadGoodsChildren();
        },
        // 批量关联：取列表勾选项
        handleBatchLink() {
            const selections = this.$refs.crud.$refs.table.selection;
            if (!selections || selections.length === 0) {
                this.$message.warning('请先勾选要批量关联的工程师');
                return;
            }
            // 校验是否有 userId
            const valid = selections.filter((s) => s && s.userId);
            if (valid.length === 0) {
                this.$message.warning('所选记录缺少工程师ID，无法关联');
                return;
            }
            this.linkMode = 'batch';
            this.linkSelections = valid;
            // 批量模式默认不回显（多个工程师可能关联不一致），由用户重新选择覆盖
            this.linkForm.goodsIds = [];
            this.linkDialogVisible = true;
            this.loadGoodsChildren();
        },
        // 加载可选子阶段（按父商品分组）
        loadGoodsChildren() {
            this.goodsLoading = true;
            this.goodsGroupList = [];
            findGoodsChildren({ type: 'WATERPROOF_PROJECT' })
                .then((res) => {
                    const data = this.parseResData(res);
                    this.goodsGroupList = Array.isArray(data) ? data : [];
                })
                .catch((err) => {
                    console.log('loadGoodsChildren error:', err);
                    this.goodsGroupList = [];
                    this.$message.error('获取可选子阶段异常');
                })
                .finally(() => {
                    this.goodsLoading = false;
                });
        },
        // 兼容 res.data 为 JSON 字符串或对象
        parseResData(res) {
            if (!res) return null;
            const raw = res.data !== undefined ? res.data : res;
            if (typeof raw === 'string') {
                try {
                    return JSON.parse(raw);
                } catch (e) {
                    return null;
                }
            }
            return raw;
        },
        // 某父分组是否全选
        isGroupAllChecked(group) {
            const children = group.children || [];
            if (children.length === 0) return false;
            return children.every((c) => this.linkForm.goodsIds.indexOf(c.id) > -1);
        },
        // 某父分组是否半选
        isGroupIndeterminate(group) {
            const children = group.children || [];
            const checkedCount = children.filter((c) => this.linkForm.goodsIds.indexOf(c.id) > -1).length;
            return checkedCount > 0 && checkedCount < children.length;
        },
        countGroupChecked(group) {
            const children = group.children || [];
            return children.filter((c) => this.linkForm.goodsIds.indexOf(c.id) > -1).length;
        },
        // 父分组全选/取消全选
        toggleGroupAll(group, checked) {
            const children = group.children || [];
            const ids = children.map((c) => c.id);
            if (checked) {
                const set = new Set(this.linkForm.goodsIds.concat(ids));
                this.linkForm.goodsIds = Array.from(set);
            } else {
                this.linkForm.goodsIds = this.linkForm.goodsIds.filter((id) => ids.indexOf(id) === -1);
            }
        },
        resetLinkForm() {
            this.linkForm.goodsIds = [];
            this.linkSelections = [];
            this.goodsGroupList = [];
            this.linkMode = 'single';
        },
        // 保存关联
        confirmLinkGoods() {
            const goodsIds = this.linkForm.goodsIds.slice();
            if (this.linkMode === 'single') {
                const target = this.linkSelections[0];
                if (!target || !target.userId) {
                    this.$message.error('未获取到目标工程师');
                    return;
                }
                this.linkSubmitLoading = true;
                saveEngineerGoods(target.userId, goodsIds)
                    .then((res) => {
                        if (res && res.code && res.code !== '200') {
                            this.$message.error(res.message || '保存失败');
                            return;
                        }
                        this.$message.success('关联已更新');
                        this.linkDialogVisible = false;
                        this.handleDetailList();
                    })
                    .catch((err) => {
                        console.log('confirmLinkGoods(single) error:', err);
                        this.$message.error('保存关联异常');
                    })
                    .finally(() => {
                        this.linkSubmitLoading = false;
                    });
                return;
            }
            // 批量
            const userIds = this.linkSelections.map((u) => u.userId).filter(Boolean);
            if (userIds.length === 0) {
                this.$message.warning('未获取到目标工程师');
                return;
            }
            this.linkSubmitLoading = true;
            batchSaveEngineerGoods(this.groupId, userIds, goodsIds)
                .then((res) => {
                    if (res && res.code && res.code !== '200') {
                        this.$message.error(res.message || '批量保存失败');
                        return;
                    }
                    this.$message.success(`已批量更新 ${userIds.length} 位工程师的关联`);
                    this.linkDialogVisible = false;
                    this.handleDetailList();
                })
                .catch((err) => {
                    console.log('confirmLinkGoods(batch) error:', err);
                    this.$message.error('批量保存关联异常');
                })
                .finally(() => {
                    this.linkSubmitLoading = false;
                });
        },
        // 切换钱包冻结状态
        handleToggleWallet(row) {
            const isFrozen = row.walletFrozen === 'YES';
            const action = isFrozen ? '解冻' : '冻结';
            const userName = row.userName || '';
            const userId = row.userId;
            if (!userId) {
                this.$message.error('该记录缺少用户ID，无法操作');
                return;
            }
            this.$confirm(`确定${action} ${userName} 的钱包吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const apiCall = isFrozen ? unfreezeWallet(userId) : freezeWallet(userId);
                apiCall
                    .then(res => {
                        if (res.code === '200') {
                            this.$message.success(`${action}成功`);
                            this.handleDetailList();
                        } else {
                            this.$message.error(`${action}失败：` + (res.message || '未知错误'));
                        }
                    })
                    .catch(error => {
                        console.log(`${action} wallet error:`, error);
                        this.$message.error(`${action}钱包异常`);
                    });
            }).catch(() => {
                this.$message.info(`已取消${action}`);
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__body {
    padding: 15px;
}

/* 表格样式优化 */
.avue-crud__header {
    padding: 10px 0;
}

/* 关联子阶段弹窗 */
.link-targets {
    padding: 8px 12px;
    margin-bottom: 12px;
    background: #f5f7fa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    font-size: 13px;
    color: #606266;
    line-height: 1.6;

    i {
        color: #409eff;
        margin-right: 4px;
    }
}

.goods-group {
    margin-bottom: 16px;
    padding: 10px 12px;
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 6px;

    &__head {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }

    &__title {
        font-weight: 600;
        color: #303133;
        margin-left: 4px;
    }

    &__count {
        margin-left: auto;
        font-size: 12px;
        color: #909399;
    }

    &__body {
        display: flex;
        flex-wrap: wrap;
        padding-left: 24px;

        ::v-deep .el-checkbox {
            margin-right: 16px;
            margin-bottom: 6px;
            margin-left: 0;
        }
    }
}

.link-empty {
    padding: 32px;
    text-align: center;
    color: #909399;
    font-size: 13px;

    i {
        margin-right: 6px;
        font-size: 16px;
    }
}

.link-tip {
    margin-top: 8px;
    padding: 8px 12px;
    font-size: 12px;
    color: #606266;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 4px;
    line-height: 1.6;

    i {
        color: #e6a23c;
        margin-right: 4px;
    }

    strong {
        color: #f56c6c;
    }
}
</style>